import http from './httpService';

let apiEndpoint = '/topBars';

export function getTopBarData() {
  return http.get(`${apiEndpoint}`);
}
